"use client";

export default function ProcessingStepsButton({
  functionName,
  steps,
  currentStep,
}: {
  functionName: string;
  steps: readonly string[];
  currentStep: number;
}) {
  const activeStep = Math.max(
    0,
    Math.min(currentStep, Math.max(steps.length - 1, 0)),
  );
  const activeLabel = steps[activeStep] ?? "Preparing";

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={`Processing ${functionName}: ${activeLabel}`}
      className="w-full max-w-md rounded-lg border border-blue-200 bg-white p-4 shadow-lg"
    >
      <button
        type="button"
        disabled
        className="inline-flex w-full cursor-wait items-center justify-center gap-2 rounded-md bg-[#0056b3] px-4 py-2.5 text-sm font-semibold text-white disabled:opacity-100"
      >
        <span
          aria-hidden="true"
          className="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white"
        />
        Processing {functionName}
      </button>
      <p className="mt-3 text-sm font-semibold text-zinc-900">
        Step {activeStep + 1} of {steps.length}: {activeLabel}
      </p>
      <ol className="mt-2 space-y-1 text-xs text-zinc-600">
        {steps.map((step, index) => (
          <li
            key={step}
            className={
              index === activeStep ? "font-semibold text-blue-700" : undefined
            }
          >
            <span
              aria-hidden="true"
              className="mr-1.5 inline-block w-3 text-center"
            >
              {index < activeStep ? "✓" : index === activeStep ? "•" : "○"}
            </span>
            {step}
          </li>
        ))}
      </ol>
    </div>
  );
}
